<template>
    <div class="pop_up_layer" style="display: block" @click="closeModal"></div>
    <div class="pop_up" style="display: block">
        <div class="pop_tit _flex _bb">
            <p v-if="props.gubun == 1">개인정보 처리 방침</p>
            <p v-else>서비스 이용약관 수정</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sign_form agree_form">
            <textarea id="editor1" name="editor1"></textarea>
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _gray" @click="closeModal">취소</button>
                <button class="submit_btn _130 _main_blue" @click="save">수정</button>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import {
        onMounted,
        reactive,
        watch,
        onUnmounted,
        CommonUtils,
        apiService,
        types,
        getMessageByCode,
        CkEditorManager,
        onBeforeUnmount,
    } from "@/BaseComponent";

    export default {
        props: {
            gubun: {
                type: Number,
                default: 0,
            },
            data: {
                type: String,
                defalut: "",
            },
        },
        emits: ["close", "callback"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                gubun: 0 as number,
                content: "" as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
            });

            let editorManager: CkEditorManager | null = null;

            onMounted(async () => {
                editorManager = new CkEditorManager("editor1", state);
                await editorManager.initEditor();

                state.gubun = props.gubun;
                state.content = props.data;

                await editorManager?.setDataInfo(state.content);
                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, async () => {
                state.gubun = props.gubun;
                state.content = props.data;
                await editorManager?.setDataInfo(state.content);
            });

            onBeforeUnmount(() => {
                editorManager?.destroy();
            });

            const closeModal = () => {
                emit("close");
            };

            const save = async () => {
                state.content = (await editorManager?.getData()) + "";

                const key = state.gubun === 1 ? "privacy_terms" : "use_terms";
                const name = state.gubun === 1 ? "개인정보 처리방침" : "이용약관";
                emit("callback", { key, name, value: CommonUtils.encodeContent(state.content) });
            };

            return { state, closeModal, props, CommonUtils, save };
        },
    };
</script>
